import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const PaymentBonusesSection = () => (
  <>
    <SectionHeading>Payment of Bonuses</SectionHeading>

    <ListItem marker="(a)">
      {"Subject to clause 7(a) above, unless otherwise indicated in the applicable Key Terms, all real money bonuses will be paid into the Accounts of Qualifying Players any time within seven (7) days of entry into the relevant Promotion."}
    </ListItem>

    <ListItem marker="(b)">
      {"Your use of any real money bonuses is subject to Our review for irregular playing patterns. In the event that We deem that an irregular playing pattern has taken place, We reserve the right to prevent you from cashing out Account funds and/or withhold any of Your winnings derived from Your use of the bonus."}
    </ListItem>

    <ListItem marker="(c)" withBottomMargin>
      {"In the event that more than one real money bonus or any excess payment is accidentally paid to a Qualifying Player, We reserve the right, without prejudice to any other rights under the Rules, to seek the return of the amount of any additional real money bonus or payment from that player's Account."}
    </ListItem>
  </>
);

export default PaymentBonusesSection;
